import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import "./App.css";
import Home from "./pages/Home";
import ScrollToTopOnRouteChange from "./components/common/ScrollToTopOnRouteChange";
import MonsterEncyclopedia from "./pages/MonsterEncyclopedia";
import Certificate from "./pages/Certificate";
import Quiz from "./pages/Quiz";
import RankingBoard from "./pages/RankingBoard";
import HowToPlay from "./pages/HowToPlay";
import { initializeMigration } from "./utils/migrationUtils";
import AutoBGM from "./components/common/AutoBGM";

function App() {
  useEffect(() => {
    initializeMigration();
  }, []);

  return (
    <Router>
      <ScrollToTopOnRouteChange />
      <div className="App">
        <main 
          className="flex flex-col w-full h-[100vh]"
          style={{
            backgroundImage: 'url(./web-background.png)',
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
          }}
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/how-to-play" element={<HowToPlay />} />
            <Route path="/monster-encyclopedia" element={<MonsterEncyclopedia />} />
            <Route path="/certificate" element={<Certificate />} />
            <Route path="/quiz" element={<Quiz />} />
            <Route path="/ranking-board" element={<RankingBoard />} />
          </Routes>
          
          <AutoBGM bgmSrc="/audio/BestAdventureEver.mp3" volume={0.3} />
        </main>
        <Toaster 
          position="top-right"
          toastOptions={{
            duration: 4000,
            style: {
              background: '#1e293b',
              color: '#f8fafc', 
              border: '1px solid #334155',
              borderRadius: '0.75rem',
              padding: '16px',
              fontSize: '14px',
              fontWeight: '500',
              boxShadow: '0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1)',
            },
            success: {
              duration: 3000,
              style: {
                background: '#065f46',
                color: '#d1fae5',
                border: '1px solid #10b981',
              },
              iconTheme: {
                primary: '#10b981',
                secondary: '#d1fae5',
              },
            },
            error: {
              duration: 5000,
              style: {
                background: '#7f1d1d',
                color: '#fecaca',
                border: '1px solid #ef4444',
              },
              iconTheme: {
                primary: '#ef4444',
                secondary: '#fecaca',
              },
            },
            loading: {
              style: {
                background: '#374151',
                color: '#f3f4f6',
                border: '1px solid #6b7280',
              },
            },
          }}
          gutter={16}
          containerStyle={{
            top: 20,
            right: 20,
          }}
        />
      </div>
    </Router>
  );
}

export default App;
